import DeviceType from './DeviceType';

// Datei aus dem Netz in den lokalen Speicher des Geraets holen.
//
// Gebraucht fuer das Clonefile auf Samsung: webapis.clone.restoreCloneData()
// nimmt einen LOKALEN PFAD, keine URL. Ohne diesen Schritt liesse sich ein
// Clonefile nur per USB auf das Geraet bringen, und ein Fern-Rollout waere auf
// Samsung nicht moeglich. Auf LG braucht es das nicht - dort nimmt
// requestCloning() das XML direkt entgegen.
//
// VORAUSSETZUNG auf Samsung: das Privileg
//   http://tizen.org/privilege/download
// in der config.xml des WGT (zusaetzlich zu filesystem.write, das dort schon
// steht). Fehlt es, wirft tizen.download.start und diese Funktion meldet den
// Grund zurueck - der Aufrufer kann dann auf den Pfad-Weg ausweichen. Die
// config.xml liegt nicht in diesem Repo, sondern beim WGT-Packaging.

/** Zielordner im Sinne der Tizen-Download-API (virtuelle Wurzel). */
const DESTINATION = 'downloads';

function api() {
  try {
    if (typeof tizen === 'undefined' || !tizen) return null;
    if (!tizen.download || typeof tizen.download.start !== 'function') return null;
    if (typeof tizen.DownloadRequest !== 'function') return null;
    return tizen.download;
  } catch (e) {
    return null;
  }
}

/** Dateiname aus einer Url ziehen, ohne Query und Fragment. */
export function fileNameFromUrl(url, fallback) {
  try {
    const clean = String(url).split('#')[0].split('?')[0];
    const last = clean.substring(clean.lastIndexOf('/') + 1);
    if (last) return decodeURIComponent(last);
  } catch (e) {
    /* unten weiter */
  }
  return fallback || 'download.bin';
}

export default class Download {
  /** Kann dieses Geraet ueberhaupt herunterladen? */
  static isAvailable() {
    return !!api();
  }

  /**
   * Laedt `url` in den Downloads-Ordner des Geraets.
   *
   * onProgress bekommt { received, total, percent } - percent ist null, solange
   * die Gesamtgroesse unbekannt ist (der Server muss dafuer Content-Length
   * schicken).
   *
   * Rueckgabe: Promise<string> mit dem vollstaendigen lokalen Pfad, den
   * restoreCloneData() erwartet.
   */
  static toLocalFile(url, fileName, onProgress) {
    const download = api();
    if (!download) {
      return Promise.reject(
        new Error(
          DeviceType.isLG
            ? 'Download-API nur auf Samsung vorhanden'
            : 'tizen.download nicht verfuegbar (Privileg download in der config.xml?)'
        )
      );
    }
    const name = fileName || fileNameFromUrl(url);

    return new Promise((resolve, reject) => {
      let request;
      try {
        request = new tizen.DownloadRequest(url, DESTINATION, name);
      } catch (e) {
        reject(new Error('DownloadRequest abgelehnt: ' + String((e && e.message) || e)));
        return;
      }

      let id = null;
      const listener = {
        onprogress: function (downloadId, receivedSize, totalSize) {
          if (!onProgress) return;
          const received = Number(receivedSize) || 0;
          const total = Number(totalSize) || 0;
          onProgress({
            received: received,
            total: total,
            percent: total > 0 ? Math.round((received / total) * 100) : null,
          });
        },
        onpaused: function () {
          /* Pausieren loesen wir nicht aus; nur der Vollstaendigkeit halber. */
        },
        oncanceled: function () {
          reject(new Error('Download abgebrochen'));
        },
        oncompleted: function (downloadId, fullPath) {
          // fullPath ist genau das, was restoreCloneData() braucht.
          resolve(String(fullPath));
        },
        onfailed: function (downloadId, error) {
          reject(new Error('Download fehlgeschlagen: ' + String((error && error.message) || error)));
        },
      };

      try {
        id = download.start(request, listener);
        console.log('[Download] gestartet (' + id + '): ' + url);
      } catch (e) {
        reject(new Error('Download nicht startbar: ' + String((e && e.message) || e)));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Download.js